import React from "react";
import {
  TextInput,
  SimpleForm,
  required,
  PasswordInput,
  CreateProps,
} from "react-admin";
import SanitizedGrid from "components/SanitizedGrid";
import RetypePasswordInput from "components/RetypePasswordInput";
import { Grid, Typography } from "@material-ui/core";
import CustomCreateToolbar from "components/CustomCreateToolbar";
import { mobilePhoneNoValidation, vaNumberValidation } from "utils/validation";
import CustomAddressAutoCompleteInput from "./components/CustomAddressAutoCompleteInput";
import EmailInput from "../../components/EmailInput";
import NameInput from "../../components/NameInput";
import CreateWrapper from "../../components/CreateWrapper";

const CompanyCreate = (props: CreateProps) => {
  const breadcrumb = [
    { title: "Companies", link: "/companies" },
    { title: "Create", link: "/companies/create" },
  ];

  const transform = async (data: any) => {
    data.lat = data.locationData.LATITUDE;
    data.lng = data.locationData.LONGITUDE;

    delete data.locationData;

    return data;
  };

  return (
    <>
      <CreateWrapper
        breadcrumb={breadcrumb}
        headerTitle="New Company"
        transform={transform}
        {...props}
      >
        <SimpleForm toolbar={<CustomCreateToolbar />}>
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">Company Details</Typography>
            </Grid>

            <Grid item xs={4}>
              <NameInput label="Name" source="name" />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <EmailInput label="Email" source="user.email" />
            </Grid>
            <Grid item xs={4}>
              <TextInput
                label="Mobile No."
                source="mobile"
                validate={mobilePhoneNoValidation}
              />
            </Grid>
            <Grid item xs={4}></Grid>

            <Grid item xs={4}>
              <PasswordInput
                label="Password"
                source="user.password"
                validate={required()}
              />
            </Grid>
            <Grid item xs={4}>
              <RetypePasswordInput />
            </Grid>
            <Grid item xs={4}></Grid>

            <Grid item xs={4}>
              <TextInput
                label="VA Number"
                source="vaNumber"
                validate={vaNumberValidation}
              />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Address Detail</Typography>
            </Grid>

            <Grid item xs={4}>
              <CustomAddressAutoCompleteInput
                label="Postal Code"
                source="postalCode"
                referenceSource="locationData"
              />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={2}>
              <TextInput label="Unit No." source="unitNumber" />
            </Grid>
            <Grid item xs={2}>
              <TextInput label="Block No." source="blockNumber" />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <TextInput label="Building Name" source="building" />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <TextInput
                label="Address"
                source="address"
                validate={required()}
              />
            </Grid>
            <Grid item xs={8}></Grid>
          </SanitizedGrid>
        </SimpleForm>
      </CreateWrapper>
    </>
  );
};

export default CompanyCreate;
